<div class="container">
  <app-template [title]="Report">
    <div class="" [ngSwitch]="mode">
      <div *ngSwitchCase="'view'" style="padding-bottom: 300px">
        <div class="top">
          <button
            type="button"
            class="button"
            mat-raised-button
            color="primary"
            *ngIf="!isLoading"
            (click)="getTemplate()"
          >
            Generate
          </button>
          <button
            type="button"
            class="button"
            mat-raised-button
            color="primary"
            *ngIf="isLoading"
            (click)="getTemplate()"
          >
            Generate <i class="fa fa-cog fa-spin"></i></button
          ><span class="name">{{ name }}</span>

          <a
            routerLink="/report/create-template"
            class="waves-effect pull-right"
            style="margin-left: 20px"
          >
            <button
              type="button"
              class="button"
              mat-raised-button
              color="primary"
              style="width: 120px; float: right; margin-left: 20px"
            >
              New Template
            </button>
          </a>
          <a
            routerLink="/report/create-parameter"
            class="waves-effect pull-right"
          >
            <button
              type="button"
              class="button"
              mat-raised-button
              color="primary"
              style="width: 120px; float: right"
            >
              New Parameter
            </button>
          </a>
        </div>
        <table class="table">
          <thead>
            <tr>
              <th style="padding-left: 10px">Name</th>
              <th style="padding-left: 10px">Description</th>
              <th style="padding-left: 10px">QueryText</th>
              <th style="padding-left: 10px">Module Code</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let data of template"
              class="row"
              (click)="select(data)"
            >
              <td style="padding-left: 10px">
                {{ data.Name }}
              </td>
              <td style="padding-left: 10px">
                {{ data.Description }}
              </td>
              <td style="padding-left: 10px">
                {{ data.QueryText }}
              </td>
              <td style="padding-left: 10px">
                {{ data.ModuleCode }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        *ngSwitchCase="'result'"
        class="result"
        style="padding-bottom: 300px"
      >
        <div class="top">
          <form class="params" autocomplete="off">
            <div class="form" *ngFor="let param of params">
              <ng-container [ngSwitch]="param.ParameterType">
                <span class="form" *ngSwitchCase="'Lookup'">
                  <!-- <select class="select" ngModel="Access Modes" (ngModelChange)="setACM($event)" [ngModelOptions]="{standalone: true}">
                                        <option selected="selected" disabled hidden value="Access Modes">{{param.Name}}</option>
                                        <option *ngFor="let data of ACM" [ngValue]="data">{{data.name}}</option>
                                    </select>  -->
                  <mat-form-field *ngIf="!refdrmode">
                    <mat-label>{{ param.Name }}</mat-label>
                    <mat-select
                      matNativeControl
                      (selectionChange)="
                        slectOnChange($event, param.Name, param.ParameterType)
                      "
                      [ngSwitch]="param.ParameterCode"
                    >
                      <ng-container *ngSwitchCase="'PYTMDS'">
                        <mat-option
                          *ngFor="let data of PYTMDS"
                          [value]="data.Id"
                        >
                          {{ data.Name }}
                        </mat-option>
                      </ng-container>
                      <ng-container *ngSwitchCase="'CASHIER'">
                        <mat-option
                          *ngFor="let data of CASHIER"
                          [value]="data.Id"
                        >
                          {{ data.Name }}
                        </mat-option>
                      </ng-container>
                      <ng-container *ngSwitchCase="'ACM'">
                        <mat-option *ngFor="let data of ACM" [value]="data.Id">
                          {{ data.Name }}
                        </mat-option>
                      </ng-container>
                      <ng-container *ngSwitchCase="'Currency'">
                        <mat-option
                          *ngFor="let data of Currency"
                          [value]="data.Id"
                        >
                          {{ data.Name }}
                        </mat-option>
                      </ng-container>
                      <ng-container *ngSwitchCase="'DEPT'">
                        <mat-option *ngFor="let data of DEPT" [value]="data.Id">
                          {{ data.Name }}
                        </mat-option>
                      </ng-container>

                      <ng-container *ngSwitchCase="'Access'">
                        <mat-option
                          *ngFor="let data of Access"
                          [value]="data.Id"
                        >
                          {{ data.Name }}
                        </mat-option>
                      </ng-container>
                    </mat-select>
                  </mat-form-field>
                  <span [ngSwitch]="param.ParameterCode">
                    <mat-form-field *ngSwitchCase="'REFDOC'">
                      <mat-label>Ref Dr</mat-label>
                      <input
                        [(ngModel)]="refDrName"
                        (ngModelChange)="refchg($event)"
                        matInput
                        [ngModelOptions]="{ standalone: true }"
                        required
                      />
                      <div class="float" style="position: relative; width: 3px">
                        <div class="ret" *ngIf="drVisible">
                          <div class="list" *ngIf="refLoad">Loading</div>
                          <div
                            class="list"
                            (click)="
                              setRefDr(dr, param.Name, param.ParameterType)
                            "
                            *ngFor="let dr of searchRef"
                          >
                            {{ dr.Name }}
                          </div>
                        </div>
                      </div>
                    </mat-form-field>
                  </span>
                </span>
                <span class="form" *ngSwitchCase="'String'">
                  <mat-form-field>
                    <mat-label>{{ param.Name }}</mat-label>
                    <input
                      matInput
                      [placeholder]="param.Name"
                      (change)="
                        onChange($event, param.Name, param.ParameterType)
                      "
                    />
                  </mat-form-field>
                </span>
                <span class="form" *ngSwitchCase="'Date'">
                  <mat-form-field class="size">
                    <mat-label>{{ param.Name }}</mat-label>
                    <input
                      matInput
                      [matDatepicker]="dob"
                      (dateChange)="
                        DateChange($event, param.Name, param.ParameterType)
                      "
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="dob"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #dob></mat-datepicker>
                  </mat-form-field>
                </span>
                <span class="form" *ngSwitchCase="'Number'">
                  <mat-form-field>
                    <mat-label>{{ param.Name }}</mat-label>
                    <input
                      type="number"
                      matInput
                      [placeholder]="param.Name"
                      (change)="
                        onChange($event, param.Name, param.ParameterType)
                      "
                    />
                  </mat-form-field>
                </span>
              </ng-container>
            </div>
            <div class="button">
              <button
                type="button"
                class="button"
                mat-raised-button
                color="primary"
                (click)="back()"
                style="width: 90px"
              >
                Back
              </button>
              <button
                type="button"
                class="button"
                mat-raised-button
                color="primary"
                (click)="onSubmit()"
                style="width: 90px; margin-left: 20px"
              >
                Generate
              </button>
              <button
                mat-raised-button
                class="button"
                color="primary"
                style="margin-left: 20px"
                (click)="exportexcel()"
              >
                Export
              </button>
            </div>
          </form>
        </div>
        <div class="loaderC">
          <i class="fa fa-cog fa-spin loader" *ngIf="isLoadresult"></i
          ><i class="fa fa-cog fa-spin loader" *ngIf="isLoadresult"></i>
        </div>
        <div id="print-section">
          <table id="table" class="table" *ngIf="!isLoadresult">
            <thead>
              <tr>
                <th
                  style="padding-left: 10px; font-size: 15px"
                  *ngFor="let row of lstColumnNames"
                >
                  {{ row.Name }}
                </th>
              </tr>
            </thead>
            <tbody>
              
              <tr *ngFor="let row of rowNames">
                <ng-container *ngFor="let i of [].constructor(row.length); let idx = index">
                  <td style="padding-left: 10px">{{ row[idx] }}</td>
                </ng-container>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </app-template>
</div>
